/** @format */

export const PDP_CONSTANTS = {
	appPathPrefix: 'p'
};

export const adeptmindScriptPath = 'https://www.dickssportinggoods.com/a/js/pdpScript.js';
export const adeptmindPLAScriptPath = 'https://amt.adeptmind.ai/9b2c19e3/amt.js'; // move to env files if this becomes brand/environment-specific in the future
